import * as lucideicons from "lucide-react";
import * as hiicons from "react-icons/hi";
import * as FaIcons from "react-icons/fa";
import * as SiIcons from "react-icons/si";
import * as MdIcons from "react-icons/md";
import * as riIcons from 'react-icons/ri';
import * as ioicons from 'react-icons/io5';
import * as iofaicins from "react-icons/fa6";

const icons = {
  ...FaIcons,
  ...SiIcons,
  ...MdIcons,
  ...hiicons,
  ...lucideicons,
  ...ioicons,
  ...riIcons,
  ...iofaicins
};

export default icons;
